import * as React from "react";
import { CheckCircle, Loader as LoaderIcon } from "react-feather";

interface RedirectingProps {
  message: string;
}

const Redirecting: React.FC<RedirectingProps> = props => {

  return (
    <div className="o-overlay d-flex flex-column justify-content-center align-items-center px-3 py-5">
      <div className="text-primary">
        <CheckCircle size={48} />
      </div>
      <div className="text-secondary text-center fs-7 mt-4">
        {props.message}
      </div>
      <div className="d-flex align-items-center mt-5">
        <LoaderIcon className="animate-spin" />
        <div className="ml-2 fs-8">Please wait...</div>
      </div>
    </div>
  );
};

export default Redirecting;
